import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import YoybuyVsKakobuy from "@/pages/article/yoybuy-vs-kakobuy/page";
import HowToBuyTaobao from "@/pages/article/how-to-buy-from-taobao/page";
import BestChinaAgents from "@/pages/article/best-china-agents-2026/page";
import SpreadsheetSecrets from "@/pages/article/spreadsheet-comparison-secrets/page";
import ChinaShipping from "@/pages/article/china-shipping-guide/page";
import HowToChooseAgent from "@/pages/article/how-to-choose-agent/page";
import PromoCodes from "@/pages/article/promo-codes-2026/page";
import BeginnerFirstOrder from "@/pages/article/beginner-first-order/page";
import Top10Products from "@/pages/article/top-10-products-china/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/yoybuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/yoybuy-vs-kakobuy",
    element: <YoybuyVsKakobuy />,
  },
  {
    path: "/article/how-to-buy-from-taobao",
    element: <HowToBuyTaobao />,
  },
  {
    path: "/article/best-china-agents-2026",
    element: <BestChinaAgents />,
  },
  {
    path: "/article/spreadsheet-comparison-secrets",
    element: <SpreadsheetSecrets />,
  },
  {
    path: "/article/china-shipping-guide",
    element: <ChinaShipping />,
  },
  {
    path: "/article/how-to-choose-agent",
    element: <HowToChooseAgent />,
  },
  {
    path: "/article/promo-codes-2026",
    element: <PromoCodes />,
  },
  {
    path: "/article/beginner-first-order",
    element: <BeginnerFirstOrder />,
  },
  {
    path: "/article/top-10-products-china",
    element: <Top10Products />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;